// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
/** The Hasura roles that may read ballot box seals, in the order they're tried. */
export var SEAL_READ_ROLES = [
    IPermissions.ELECTION_DASHBOARD_TAB,
    IPermissions.TALLY_READ,
    IPermissions.ADMIN_USER,
];
/** The first role of `SEAL_READ_ROLES` the user has, or null when none. */
export var sealReadRole = function (hasRole) { var _a; return (_a = SEAL_READ_ROLES.find(function (role) { return hasRole === null || hasRole === void 0 ? void 0 : hasRole(role); })) !== null && _a !== void 0 ? _a : null; };
/**
 * A role the signed-in user has that may read ballot box seals (VOTE-FREEZE),
 * so a page outside the Dashboard (deleting, the event's incident banner) can
 * read them; null when the user has none and the seals can't be read.
 */
export var useSealReadRole = function () {
    var hasRole = useContext(AuthContext).hasRole;
    return sealReadRole(hasRole);
};
